<template>
  <section class="inventory--part-details animated fadeIn">
    <div class="list-group-item mb-2">
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.generalCartonInspection_ProductWeight"
      >
        <span class="col-form-label">Weigh Product Contents and Record</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.generalCartonInspection_OuterPackageDamage"
      >
        <span class="col-form-label">Inspect outer package for evidence of damage</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.generalCartonInspection_PhotoDamage"
      >
        <span class="col-form-label">Photograph/record any findings</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.generalCartonInspection_SealingTape"
      >
        <span class="col-form-label">Inspect the sealing tape for evidence of tangering</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.generalCartonInspection_PackageClaim"
      >
        <span
          class="col-form-label"
        >If damage or evidence of tampering is present note findings and alert the vendor and carrier for possible frieght claim</span>
      </b-form-radio-group>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {FIELDS}  from '../../constants'
export default {
  name: 'ideaGeneralCarton',
  components: {},
  props: {
    inspectionDetails: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        generalCartonInspection_ProductWeight: this.inspectionDetails[FIELDS.GENERAL_CARTON_INSPECTION__PRODUCT_WEIGHT] || '',
        generalCartonInspection_OuterPackageDamage: this.inspectionDetails[FIELDS.GENERAL_CARTON_INSPECTION__OUTER_PACKAGE_DAMAGE] || '',
        generalCartonInspection_PhotoDamage: this.inspectionDetails[FIELDS.GENERAL_CARTON_INSPECTION__PHOTO_DAMAGE] || '',
        generalCartonInspection_SealingTape: this.inspectionDetails[FIELDS.GENERAL_CARTON_INSPECTION__SEALING_TAPE] || '',
        generalCartonInspection_PackageClaim: this.inspectionDetails[FIELDS.GENERAL_CARTON_INSPECTION__PACKAGE_CLAIM] || '',
      },
    };
  },
  computed: {},
  mounted() {},
};
</script>